/* unplugin-vue-components disabled */import { render } from "./LoadingSkeleton.vue?vue&type=template&id=91f5a1be"
import script from "./LoadingSkeleton.vue?vue&type=script&lang=js"
export * from "./LoadingSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.33_vue@3.5.33_typescript@6.0.3__webpack@5.106.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__